import { gql } from '@apollo/client';

/**
 * The queue, live.
 *
 * Without it the console is a page somebody has to remember to refresh while a
 * customer waits. Each event names what happened to which ticket, so the list
 * is patched rather than refetched.
 */
export const SUPPORT_ESCALATION_STREAM = gql`
  subscription SupportEscalationStream {
    supportEscalationStream {
      eventType
      ticketId
      subject
      category
      priority
      threadName
      formerOwner
      reason
    }
  }
`;
